import React, {Component, Fragment} from 'react';
import style from '../css/complexBetGameCard.css';
import {connect} from 'react-redux';
// constants
import {ASSETS_URL} from '../../../../../constants/endpoints';
// helpers
import {getOddsFromOddsType} from '../../../../../helpers/oddsHelpers';
import {hasEventTypeRacerNumberUI, isMarbleEuroEvent, isMarbleNonEuroEvent} from '../helpers/racersHelper';
// components
import ComplexButton from "./complexButton";
//actions
import {getText} from '../../../../../helpers/localization';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedEventMultiBetList: state.vpp.selectedEventMultiBetList,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage,
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
    };
};

class ComplexBetGameCard extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage,
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState(
                {
                    events: storeData.vpp.events,
                    selectedEventIndex: storeData.vpp.selectedEventIndex,
                    selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
                    selectedRacingBetType: storeData.vpp.selectedRacingBetType,
                    selectedOddsType: storeData.vpp.selectedOddsType,
                    systemLanguage: storeData.vpp.systemLanguage,
                    games: storeData.vpp.games,
                    selectedGameIndex: storeData.vpp.selectedGameIndex,
                }
            );
        }
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let eventType = this.state.events[this.state.selectedEventIndex].eventType;
        let odd = getOddsFromOddsType(this.props.racer.oddsFirst, this.state.selectedOddsType);
        let racerNumberStyle = hasEventTypeRacerNumberUI(eventType) ? style.racerNumber : '';

        let gameName = this.state.games[this.state.selectedGameIndex].name;
        let isMarbleSand = isMarbleNonEuroEvent(eventType, gameName);
        let racerName = isMarbleEuroEvent(eventType, gameName) ? getText(gameName + "_" + this.props.racer.num, this.props.store) : this.props.racer.name.toLowerCase();
        let racerImage;
        if (isMarbleEuroEvent(eventType, gameName))
            racerImage = `${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/marbles/silk${Number(this.props.racer.silk) + 1}.png`;
        else
            racerImage = `${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(this.props.racer.silk) + 1}.png`;
        return (
            <div
                className={`${style.complexBetGameCardContainer} ${this.props.isLast
                    ? style.last
                    : ''} ${this.props.index % 2 !== 0
                    ? style.odd
                    : ''}`}>
                <div className={style.racerCard}>
                    <div className={style.racerIcon}>
                        <img
                            src={racerImage}
                            className={style.racerIconImage}
                            alt={`icon${this.props.racer.silk}`}/>
                    </div>
                    {isMarbleSand ? (
                        <div className={style.marbleOddsWrapper}>
                            <div className={style.marbleRacerNumber}>{this.props.racer.num}</div>
                            <div className={style.marbleRacerOdds}>{odd}</div>
                        </div>
                    ) : (<Fragment>
                        <div
                            className={`${racerNumberStyle}`}>{hasEventTypeRacerNumberUI(eventType) ? this.props.racer.num : ''}</div>
                        <div className={style.racerNameOddsContainer}>
                            <div className={style.racerName}>{racerName}</div>
                            <div className={style.hyphen}> -</div>
                            <div className={style.oddsContainer}>
                                <div className={style.odds}>{odd}</div>
                            </div>

                        </div>
                    </Fragment>)}
                </div>

                <div className={style.buttonContainer}>
                    <ComplexButton store={this.props.store} racer={this.props.racer}
                                   circleSize={'medium'}></ComplexButton>
                </div>

            </div>
        );
    }

}

export default connect(mapStateToProps)(ComplexBetGameCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/components/complexBetGameCard.js